// Gemini API設定
export const GEMINI_API_CONFIG = {
  baseURL: 'https://generativelanguage.googleapis.com/v1beta',
  model: 'gemini-2.5-flash-lite',
  generationConfig: {
    temperature: 0.7,
    topK: 40,
    topP: 0.95,
    maxOutputTokens: 2048,
  },
  safetySettings: [
    {
      category: 'HARM_CATEGORY_HARASSMENT',
      threshold: 'BLOCK_MEDIUM_AND_ABOVE'
    },
    {
      category: 'HARM_CATEGORY_HATE_SPEECH',
      threshold: 'BLOCK_MEDIUM_AND_ABOVE'
    },
    {
      category: 'HARM_CATEGORY_SEXUALLY_EXPLICIT',
      threshold: 'BLOCK_MEDIUM_AND_ABOVE'
    },
    {
      category: 'HARM_CATEGORY_DANGEROUS_CONTENT',
      threshold: 'BLOCK_MEDIUM_AND_ABOVE'
    }
  ],
  summaryConfig: {
    temperature: 0.3,
    topK: 20,
    topP: 0.8,
    maxOutputTokens: 50,
  }
};

// LocalStorage キー
export const STORAGE_KEYS = {
  apiKey: 'gemini_api_key',
  conversations: 'conversations'
};

// API エラーメッセージ
export const API_ERROR_MESSAGES = {
  invalidApiKey: 'APIキーが無効です。正しいAPIキーを入力してください。',
  noApiKey: 'APIキーが設定されていません',
  noResponse: '応答が生成されませんでした',
  aborted: '応答の生成が中止されました',
  summaryFailed: 'サマリー生成に失敗しました',
  unexpected: '予期しないエラーが発生しました',
  generic: '応答の生成中にエラーが発生しました'
};